import * as api from './base';

/**
 * 
 * @returns 我的信息
 */
export const MyInfo = () => api.get({
    url: "Member/MyBanks",
    params: {},
    loading: "加载中"
});

// 添加银行
export const addBank = (data) => api.post({
	url: "Member/AddNewBank",
	data,
	loading: "加载中"
});
// 修改银行
export const modifyBank = (data) => api.post({
	url: "Member/ModifyBank",
	data,
	loading: "加载中"
});